import React from 'react'
import { Link } from "react-router-dom";

function Newindex() {
  return (
    <div>
        <div>
  <div className="page-wrapper">
    <header id="header">
      <div className="container-lg">
        <div className="header-left">
          <div className="logo">
            <a href="#"><img src="asset/images/demos-img/logo.png" alt="Molla Logo" /></a>
          </div>
        </div>
        <div className="header-main">
          <ul className="menu">
            <li>
              <a href="#" className="goto-demos">Demos</a>
            </li>
            <li>
              <a href="#" className="goto-features">Features</a>
            </li>
            <li>
              <a href="#" className="goto-elements">Elements</a>
            </li>
            <li>
              <a href="#" className="goto-support">Support</a>
            </li>
          </ul>
        </div>
        <div className="header-right">
          <a className="mobile-menu-toggler mr-0 mr-sm-5"><i className="icon-bars" /></a>
          <Link className="btn btn-primary btn-outline" to="/"><i className="icon-shopping-cart" />Buy Molla</Link>
        </div>
      </div>
    </header>
    <div id="main">
      <section className="banner section-dark" style={{background: '#222'}}>
        <img src="asset/images/demos-img/header_splash.jpg" alt width={1920} height={1120} />
        <div className="banner-text text-center">
          <h1>Multi-Purpose eCommerce HTML5 Template</h1>
          <h5 className="mb-5">Molla is simply the best choice for your new website. Your search for the best solution is over, get your own copy and join thousands of happy customers.</h5>
          <p className="mb-0"><a href="#" className="btn btn-primary btn-outline goto-demos">Explore Demos<i className="icon-long-arrow-alt-down" /></a></p>
        </div>
      </section>
      <section className="section section-demos text-center container-lg">
        <h2>20 Pre-Build Demos</h2>
        <p>Comes with 20 homepages available with multi style that better for your choice.<br />Molla store is one of the best Multi-Purpose eCommerce HTML Template for your store.</p>
        <div className="demo-filter menu">
          <a href="#homepages" className="active">Home Pages</a>
          <a href="#shoppages">Shop Pages</a>
          <a href="#productpages">Product Pages</a>
          <a href="#otherpages">Other Pages</a>
        </div>
        <div className="row demos">
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-1.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_furniture1.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Furniture 1" />
              <h5>Furniture 1</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-2.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_furniture2.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Furniture 2" />
              <h5>Furniture 2</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-3.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_electronic1.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Electronic 1" />
              <h5>Electronic 1</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-4.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_electronic2.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Electronic 2" />
              <h5>Electronic 2</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-5.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_fashion1.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Fashion 1" />
              <h5>Fashion 1</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-6.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_fashion2.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Fashion 2" />
              <h5>Fashion 2</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-7.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_fashion3.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Fashion 3" />
              <h5>Fashion 3</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-8.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_fahion4.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Fashion 4" />
              <h5>Fashion 4</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-9.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_fashion5.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Fashion 5" />
              <h5>Fashion 5</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-10.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_shoesstore.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Shoes Store" />
              <h5>Shoes Store</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-11.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_furniture_simple.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Furniture 3" />
              <h5>Furniture 3 <span>(Simple)</span></h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-12.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_fashion_simple.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Fashion 6 (Simple)" />
              <h5>Fashion 6 <span>(Simple)</span></h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-13.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_market1.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Market" />
              <h5>Market</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-14.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_market.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Market (Full Width)" />
              <h5>Market <span>(Full Width)</span></h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-15.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_lookbook.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Lookbook 1" />
              <h5>Lookbook 1</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-16.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_lookbook2.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Lookbook 2" />
              <h5>Lookbook 2</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-17.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_fashion7.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Fashion 7" />
              <h5>Fashion 7</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-18.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_fashion8.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="ashion 8 (With Sidebar)" />
              <h5>Fashion 8 <span>(With Sidebar)</span></h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-19.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_gamestore.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Game Store" />
              <h5>Game Store</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-20.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_bookstore.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Book Store" />
              <h5>Book Store</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-21.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_sport.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Furniture 2" />
              <h5>Sport Store</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-22.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_tools.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Furniture 2" />
              <h5>Tools Store</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-23.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_fashion9.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Furniture 2" />
              <h5>Fashion 9 <span>(Left Navigation)</span></h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 homepages">
            <a href="index-24.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/molla_extreme_sport.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Furniture 2" />
              <h5>Extreme Sport Store</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 shoppages">
            <a href="category-list.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/21_shop_list.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Shop List" />
              <h5>Shop List</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 shoppages">
            <a href="category-2cols.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/22_shop_grid_2col.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Shop Grid" />
              <h5>Shop Grid <span>(2 Col)</span></h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 shoppages">
            <a href="category.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/23_shop_grid_3col.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Shop Grid" />
              <h5>Shop Grid <span>(3 Col)</span></h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 shoppages">
            <a href="category-4cols.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/24_shop_grid_4col.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Book Store" />
              <h5>Shop Grid <span>(4 Col)</span></h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 shoppages">
            <a href="category-boxed.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/25_shop_boxed_no_sidebar.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Shop Boxed" />
              <h5>Shop Boxed <span>(No Sidebar)</span></h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 shoppages">
            <a href="category-fullwidth.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/26_shop_fullwidth_no_sidebar.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Shop Fullwidth" />
              <h5>Shop Fullwidth <span>(No Sidebar)</span></h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 shoppages">
            <a href="product-category-boxed.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/27_shop_product_category_boxed.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Product Category" />
              <h5>Product Category <span>(Boxed)</span></h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 shoppages">
            <a href="product-category-fullwidth.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/28_shop_product_category_fullwidth.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Product Category" />
              <h5>Product Category <span>(Full Width)</span></h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 shoppages">
            <a href="cart.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/29_shop_shopping_cart.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Shopping Cart" />
              <h5>Shopping Cart</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 shoppages">
            <a href="checkout.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/30_shop_checkout.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Checkout" />
              <h5>Checkout</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 shoppages">
            <a href="wishlist.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/31_shop_wishlist.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Wishlist" />
              <h5>Wishlist</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 shoppages">
            <a href="dashboard.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/shop_my_account.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="My Account" />
              <h5>My Account</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 productpages">
            <a href="product.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/32_product_default.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Product default" />
              <h5>Product default</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 productpages">
            <a href="product-centered.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/33_product_centered.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Product centered" />
              <h5>Product centered</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 productpages">
            <a href="product-extended.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/34_product_extended_description_boxed.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Product extended description" />
              <h5>Product extended description</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 productpages">
            <a href="product-gallery.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/35_product_gallery.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Product gallery" />
              <h5>Product gallery</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 productpages">
            <a href="product-sticky.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/36_product_sticky_info.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Product sticky info" />
              <h5>Product sticky info</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 productpages">
            <a href="product-sidebar.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/37_product_with_sidebar.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Product with sidebar" />
              <h5>Product with sidebar</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 productpages">
            <a href="product-fullwidth.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/38_product_fullwidth.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Product fullwidth" />
              <h5>Product fullwidth</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 productpages">
            <a href="product-masonry.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/39_product_masonry_sticky_info.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Product masonry (sticky info)" />
              <h5>Product masonry <span>(sticky info)</span></h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 otherpages">
            <a href="about.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/40_pages_aboutus.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="About Us" />
              <h5>About Us</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 otherpages">
            <a href="about-2.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/41_pages_aboutus_2.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="About Us 2" />
              <h5>About Us 2</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 otherpages">
            <a href="contact.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/42_pages_contactus.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Contact Us" />
              <h5>Contact Us</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 otherpages">
            <a href="contact-2.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/43_pages_contactus_2.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Contact us 2" />
              <h5>Contact us 2</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 otherpages">
            <a href="login.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/44_pages_login.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Login page" />
              <h5>Login page</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 otherpages">
            <a href="faq.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/45_pages_FAQ.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="F.A.Q page" />
              <h5>F.A.Q page</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 otherpages">
            <a href="404.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/46_pages_error_404.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Error 404 page" />
              <h5>Error 404 page</h5>
            </a>
          </div>
          <div className="iso-item col-sm-6 col-md-4 col-lg-3 otherpages">
            <a href="coming-soon.html" target="_blank">
              <img src="asset/images/demos-img/lazy.png" data-oi="asset/images/demos-img/47_pages_coming_soon.jpg" width={500} height={385} className="molla-lz" style={{paddingTop: '77%'}} alt="Coming Soon page" />
              <h5>Coming Soon page</h5>
            </a>
          </div>
        </div>
        <h5 className="text-load-more">More New Demos Coming Soon ...</h5>
      </section>
      <section className="section section-features">
        <h2 className="text-center">Our Core Features</h2>
        <p className="text-center">Powerful features and inclusions, which makes Molla standout,<br />easily customizable and scalable.</p>
        <div className="divider-line">
          <div className="container-lg">
            <div className="overflow-hidden">
              <div className="row">
                <div className="col-sm-6 col-lg-3">
                  <div className="icon-box">
                    <i className="icon-laptop" />
                    <h4>Fully Responsive Design Layouts</h4>
                    <p>The Template looks good and sharp with all kind of devices and screen sizes. which increase the layout flexibility.</p>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-3">
                  <div className="icon-box">
                    <i className="icon-code" />
                    <h4>Clean And Professional Codes</h4>
                    <p>The Template is ready with clean and well structured coding style by the Professional developers team.</p>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-3">
                  <div className="icon-box">
                    <i className="icon-fill-drip" />
                    <h4>Creative And Modern Design Layout</h4>
                    <p>Every single section is created with the passion and years of experience in the website development.</p>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-3">
                  <div className="icon-box">
                    <i className="icon-align-left" />
                    <h4>Perfect Documentations</h4>
                    <p>There are lots of creative section for you. So we have create a documentation that will helpful to understand the flow.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-lg">
            <div className="overflow-hidden">
              <div className="row">
                <div className="col-sm-6 col-lg-3">
                  <div className="icon-box">
                    <i className="icon-th" />
                    <h4>Build With Bootstrap</h4>
                    <p>This Template is created with latest bootstrap version which used its new classes and tags.</p>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-3">
                  <div className="icon-box">
                    <i className="icon-envelope-open-text" />
                    <h4>Working Contact Form</h4>
                    <p>There are different different styled form layouts that used to get in touch with you.</p>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-3">
                  <div className="icon-box">
                    <i className="icon-cogs" />
                    <h4>Easily Customizable</h4>
                    <p>The design is fully customizable. Unlimited color styles, all 500+ Google fonts, and etc!</p>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-3">
                  <div className="icon-box">
                    <i className="icon-html5" style={{fontSize: '2.4rem'}}/>
                    <h4>Valid HTML 5 And CSS 3</h4>
                    <p>We have used latest HTML and Css Coding style that makes the pages in well working state.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section section-elements container">
        <h2 className="text-center">Elements For Everything</h2>
        <p className="text-center">Use your creativity and the power of Molla elements to create your pages,<br />check out some of them.</p>
        <br />
        <div className="row">
          <div className="col-sm-6 col-md-3 col-lg-1-5">
            <a href="elements-accordions.html" target="_blank">
              <div className="img-box">
                <i className="img-accordions" />
                <h5>Accordions</h5>
              </div>
            </a>
          </div>
          <div className="col-sm-6 col-md-3 col-lg-1-5">
            <a href="elements-banners.html" target="_blank">
              <div className="img-box">
                <i className="img-banners" />
                <h5>Banners</h5>
              </div>
            </a>
          </div>
          <div className="col-sm-6 col-md-3 col-lg-1-5">
            <a href="elements-blog-posts.html" target="_blank">
              <div className="img-box">
                <i className="img-blog-posts" />
                <h5>Blog Posts</h5>
              </div>
            </a>
          </div>
          <div className="col-sm-6 col-md-3 col-lg-1-5">
            <a href="elements-buttons.html" target="_blank">
              <div className="img-box">
                <i className="img-buttons" />
                <h5>Buttons</h5>
              </div>
            </a>
          </div>
          <div className="col-sm-6 col-md-3 col-lg-1-5">
            <a href="elements-cta.html" target="_blank">
              <div className="img-box">
                <i className="img-cta" />
                <h5>Call To Action</h5>
              </div>
            </a>
          </div>
          <div className="col-sm-6 col-md-3 col-lg-1-5">
            <a href="elements-icon-boxes.html" target="_blank">
              <div className="img-box">
                <i className="img-icon-boxes" />
                <h5>Icon Boxes</h5>
              </div>
            </a>
          </div>
          <div className="col-sm-6 col-md-3 col-lg-1-5">
            <a href="elements-portfolio.html" target="_blank">
              <div className="img-box">
                <i className="img-portfolio" />
                <h5>Portfolio</h5>
              </div>
            </a>
          </div>
          <div className="col-sm-6 col-md-3 col-lg-1-5">
            <a href="elements-product-category.html" target="_blank">
              <div className="img-box">
                <i className="img-product-categories" />
                <h5>Product Categories</h5>
              </div>
            </a>
          </div>
          <div className="col-sm-6 col-md-3 col-lg-1-5">
            <a href="elements-products.html" target="_blank">
              <div className="img-box">
                <i className="img-products" />
                <h5>Products</h5>
              </div>
            </a>
          </div>
          <div className="col-sm-6 col-md-3 col-lg-1-5">
            <a href="elements-tabs.html" target="_blank">
              <div className="img-box">
                <i className="img-tabs" />
                <h5>Tabs</h5>
              </div>
            </a>
          </div>
          <div className="col-sm-6 col-md-3 col-lg-1-5">
            <a href="elements-testimonials.html" target="_blank">
              <div className="img-box">
                <i className="img-testimonials" />
                <h5>Testimonials</h5>
              </div>
            </a>
          </div>
          <div className="col-sm-6 col-md-3 col-lg-1-5">
            <a href="elements-titles.html" target="_blank">
              <div className="img-box">
                <i className="img-titles" />
                <h5>Titles</h5>
              </div>
            </a>
          </div>
          <div className="col-sm-6 col-md-3 col-lg-1-5" target="_blank">
            <a href="elements-typography.html">
              <div className="img-box">
                <i className="img-typography" />
                <h5>Typography</h5>
              </div>
            </a>
          </div>
          <div className="col-sm-6 col-md-3 col-lg-1-5">
            <a href="elements-video-banners.html" target="_blank">
              <div className="img-box">
                <i className="img-video" />
                <h5>Video</h5>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section className="section section-support section-dark">
        <div className="container molla-lz text-center" data-oi="asset/images/demos-img/support_bg.jpg">
          <h2>Outstaning Support Center<span className="fw-400">+</span>Extensive Documentation</h2>
          <p>Support is one of our priorities, our dedicatated support<br />will be waiting for you if you have any questions.</p>
        </div>
      </section>
      <section className="section section-light section-ready container text-center">
        <h2 className="mb-3">Molla Is Ready To Use. Get It Now!</h2>
        <p>DON'T FORGET TO APPRECIATE OUR WORK. RATE US NOW!</p>
        <div className="star-rating mb-4 pb-3">
          <i className="icon-star" /><i className="icon-star" /><i className="icon-star" /><i className="icon-star" /><i className="icon-star" />
        </div>
        <p><a className="btn btn-primary btn-outline" href="#"><i className="icon-shopping-cart" />Buy Molla</a></p>
      </section>
    </div>
    <footer id="footer" className="container-lg">
      <div className="row">
        <div className="col-md-6 text-center text-md-left mb-4 mb-md-0">
          <p className="copyright mb-0"><a href="templateshub.net">Templateshub</a></p>
        </div>
        <div className="col-md-6 text-center text-md-right social-icons">
          <label className="mr-3">Social Media</label>
          <a href="#" title="Facebook"><i className="icon-facebook-f" /></a>
          <a href="#" title="Twitter"><i className="icon-twitter" /></a>
          <a href="#" title="Instagram"><i className="icon-instagram" /></a>
          <a href="#" title="Youtube"><i className="icon-youtube" /></a>
          <a href="#" title="Pinterest"><i className="icon-pinterest" /></a>
        </div>
      </div>
    </footer>
  </div>
  {/* Mobile Menu */}
  <div className="mobile-menu-overlay" />{/* End .mobil-menu-overlay */}
  <div className="mobile-menu-container">
    <div className="mobile-menu-wrapper">
      <span className="mobile-menu-close"><i className="icon-close" /></span>
      <nav className="mobile-nav">
        <ul className="mobile-menu">
          <li>
            <a href="#" className="goto-demos">Demos</a>
          </li>
          <li>
            <a href="#">Features</a>
          </li>
          <li>
            <a href="#">Elements</a>
          </li>
          <li>
            <a href="#">Support</a>
          </li>
        </ul>
      </nav>{/* End .mobile-nav */}
      <div className="d-flex justify-content-center social-icons">
        <a href="#" className="social-icon" target="_blank" title="Facebook"><i className="icon-facebook-f" /></a>
        <a href="#" className="social-icon" target="_blank" title="Twitter"><i className="icon-twitter" /></a>
        <a href="#" className="social-icon" target="_blank" title="Instagram"><i className="icon-instagram" /></a>
        <a href="#" className="social-icon" target="_blank" title="Youtube"><i className="icon-youtube" /></a>
      </div>{/* End .social-icons */}
    </div>{/* End .mobile-menu-wrapper */}
  </div>
</div>

    </div>
  )
}

export default Newindex